<ul
  [ngClass]="{ flex: flex, grid: grid }"
  [ngStyle]="{
    gap: gap !== undefined ? gap + 'px' : '',
    padding: containerPadding !== undefined ? containerPadding + 'px' : '',
    'grid-template-columns': gridColumns ? 'repeat(' + gridColumns + ', 1fr)' : ''
  }"
  >
  @for (i of Array(count).fill(1); track $index) {
    <li class="skeleton {{ style }}"></li>
  }
</ul>
